import { required } from 'AppReact/schema';

export default {
  id: required('integer'),
  name: required('string'),
  is_high_priority: required('boolean'),
  color: required('string'),
  icon: required('string'),
  index: required('integer'),
  is_default: required('boolean'),
  assigned_orders: required('boolean'),
  affects_orders: required('boolean')
};
